// Libraries
import { Dropdown, Option } from '@molecules/index';
import { useMemo } from 'react';
// Components
import { Label } from '@atoms/index';
import { ColumnFilterProps, Feature } from '@organisms/index';
import { RangeDate, useDatePickerStore } from '@stores/index';
// Utils
import text from '@translations/en.json';
// Types
import { YearPickerProps } from './YearPicker.types';

/**
 * YearPicker component for selecting a year from a dropdown menu.
 * @component
 * @returns {ReactElement} - The React element representing the YearPicker component.
 */
export const YearPicker = <TableData,>({ props, smallerViews }: ColumnFilterProps<TableData, YearPickerProps>) => {
  const { table } = props;
  const {
    CII_FLEET_RATINGS: { availableYears, selectedDate },
    setDate,
  } = useDatePickerStore();
  const label = smallerViews ? '' : text.filter_labels.year;
  const w = smallerViews ? 'full' : 50;
  const flex = smallerViews ? 1 : 0;

  /**
   * Create an array of options for the dropdown menu.
   *
   * @type {Option[]} An array of options for the dropdown menu.
   */
  const options = useMemo(
    () => availableYears.map((item) => ({ label: item.toString(), value: item })),
    [availableYears]
  );

  /**
   * Event handler for applying the selected year.
   *
   * @param {Option} option - The selected option containing the year value.
   */
  const onApply = (option: Option) => {
    setDate(option.value as unknown as RangeDate, table);
  };

  return (
    <Feature feature='yearPicker'>
      <Label label={label}>
        <Dropdown
          centerButtonText={smallerViews}
          options={options}
          // TODO: check this casted value
          value={{ label: selectedDate.toString(), value: selectedDate as unknown as number }}
          onChange={onApply}
          w={w}
          flex={flex}
        />
      </Label>
    </Feature>
  );
};
